import { useCallback } from 'react';
import { useFormContext, useFormInstance } from '@adv-frontend/form-kit';
import { OzonRegistrationButton } from '../../components/OzonRegistrationButton';
import { ORDER_FORM_ID } from '../../constants';
import { orderForm } from '../../model/forms/orderForm';

/*
 * Формирует подпись под слотом интервала доставки Ozon в зависимости от заполненности данных получателя и статуса Ozon ID.
 */
const getSubtitleText = (prefix: string, isClientFilled: boolean, isInvalidOzonUser: boolean) => {
    if (!isClientFilled) {
        return `${prefix}, для оформления заказа заполните данные получателя и авторизуйтесь в Ozon ID`;
    }

    if (isInvalidOzonUser) {
        return `${prefix}, для оформления заказа\u00a0нужен\u00a0аккаунт\u00a0Ozon\u00a0ID`;
    }

    return '';
};

interface UseOzonDeliveryIntervalStatusProps {
    openRegistrationOzon: VoidFunction;
}

/*
 * Хук для отображения интервалов доставки Ozon: подпись под слотом, статус невалидного Ozon ID и кнопка регистрации.
 *
 * @param props.openRegistrationOzon — колбэк открытия регистрации Ozon ID
 * @returns getSubtitle — функция-генератор подписи под слотом
 * @returns IsInvalidOzonUser — флаг невалидного Ozon ID
 * @returns registrationButton — элемент кнопки регистрации
 */
export const useOzonDeliveryInterval = (props: UseOzonDeliveryIntervalStatusProps) => {
    const { openRegistrationOzon } = props;

    const { fields } = useFormInstance({ form: orderForm, id: ORDER_FORM_ID });
    const context = useFormContext({ form: orderForm, id: ORDER_FORM_ID });

    const IsInvalidOzonUser = context.order.client.need_ozon_registration;

    const isClientFilled = fields.client.selectors.useGetIsFilled();

    const getSubtitle = useCallback(
        (prefix: string) => getSubtitleText(prefix, isClientFilled, IsInvalidOzonUser),
        [IsInvalidOzonUser, isClientFilled]
    );

    return {
        getSubtitle,
        IsInvalidOzonUser,
        registrationButton: <OzonRegistrationButton showIcon={false} onClick={openRegistrationOzon} />,
    };
};

export type OzonDeliveryInterval = ReturnType<typeof useOzonDeliveryInterval>;
